import { motion } from "framer-motion";
import { LucideIcon } from "lucide-react";

interface Feature {
  icon: LucideIcon;
  title: string;
  description: string;
}

interface SeoFeatureGridProps {
  features: Feature[];
  columns?: 2 | 3;
}

export const SeoFeatureGrid = ({ features, columns = 2 }: SeoFeatureGridProps) => (
  <div className={`grid grid-cols-1 ${columns === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2'} gap-4`}>
    {features.map((feature, i) => (
      <motion.div
        key={i}
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.4, delay: i * 0.1 }}
        className="p-5 rounded-xl bg-muted/50 border border-border/50 hover:border-brand-purple/30 hover:shadow-md transition-all"
      >
        <div className="p-2 rounded-lg bg-brand-purple/10 w-fit mb-3">
          <feature.icon className="w-5 h-5 text-brand-purple" />
        </div>
        <h3 className="font-montserrat font-semibold text-primary text-sm mb-1.5">{feature.title}</h3>
        <p className="text-sm text-muted-foreground leading-relaxed">{feature.description}</p>
      </motion.div>
    ))}
  </div>
);
